const registration = require('../register/registration');

require('./trialCTA');

// initial page state setup
$('.js-load-plan').addClass('hidden');
$('.js-force-yearly').addClass('hidden');

[$('#paywallwelcome'), $('#billingFailed')]
  .forEach((element) => element !== undefined && element.modal('show'));

$('.js-billing-link').on('click', () => $('#billingFailed').modal('hide'));

function setDisplayYearly (showYearlyPrices) {
  window.location.hash = showYearlyPrices ? '#yearly' : '#monthly';
  $('.js-price-yearly').toggleClass('hidden', !showYearlyPrices);
  $('.js-plan-yearly').toggleClass('hidden', !showYearlyPrices);
  $('.js-price-monthly').toggleClass('hidden', showYearlyPrices);
  $('.js-plan-monthly').toggleClass('hidden', showYearlyPrices);
  $('.js-btn-yearly').toggleClass('hidden', !showYearlyPrices);
  $('.js-your-plan').toggleClass('hidden', showYearlyPrices);
  $('.js-tab-yearly').toggleClass('active', showYearlyPrices);
  $('.js-tab-monthly').toggleClass('active', !showYearlyPrices);
}

// switch between yearly monthly pricing
$('.js-switch-yearly').on('click', function () {
  setDisplayYearly(true);
});

$('.js-switch-monthly').on('click', function () {
  setDisplayYearly(false);
});

// skip paywall button
$('.js-skip').on('click', function (event) {
  event.preventDefault();
  $('form.js-skip-paywall').submit();
});

$('.js-updowngrade .js-choose-plan, .js-choosePlan .js-choose-plan').on('click', function (event) {
  event.preventDefault();
  const chosenLink = $(this).attr('href');
  const changePlanForm = $('.js-confirm-plan');
  const priceText = $(this).parents('.js-price-box').find('.js-price:visible').text();
  changePlanForm.attr('action', chosenLink);

  $('#confirm-plan-change .price').text(priceText);
  $('#confirm-plan-change').modal();
});

// CVV re-verification (WR-464) - #confirmPlanCVV only exists in the rendered HTML for
// updowngrade/choosePlan modes (see pricing-plan-confirm.php), so its presence is the
// signal this page needs a CVV check, independent of whether recurly.js has loaded yet.
const $confirmPlanForm = $('.js-confirm-plan');
const $cvvField = $('#confirmPlanCVV');
const $cvvError = $('#confirmPlanCVVError');

if ($cvvField.length > 0) {
  // Configure as soon as recurly.js is available, not lazily on submit - Recurly needs
  // configure() called before it will attach a live hosted-field iframe to the
  // data-recurly="cvv" div, and the modal (with that div already in the DOM) can be
  // opened well before the user ever clicks Confirm.
  if (window.recurly) {
    window.recurly.configure({
      publicKey: $('#confirm-plan-recurly-public-api-key').val(),
      required: ['cvv']
    });
  }

  $confirmPlanForm.on('submit', function (event) {
    event.preventDefault();
    const $form = $(this);
    const $submitBtn = $form.find('input[type=submit]');
    const originalLabel = $submitBtn.val();

    $cvvError.addClass('hidden');

    // Fail closed: if recurly.js hasn't loaded (network issue, blocked request, etc.),
    // do NOT let the plain form POST through unverified - block the submission instead.
    if (!window.recurly) {
      $cvvError.removeClass('hidden');
      return;
    }

    $submitBtn.prop('disabled', true).val($('#confirm-plan-please-wait-i18n').val());

    window.recurly.token($form[0], (err, token) => {
      if (err) {
        $submitBtn.prop('disabled', false).val(originalLabel);
        $cvvError.removeClass('hidden');
        registration.logTokenizationErrors('pricing-plan-confirm', err, $form);
        return;
      }
      // Native submit - bypasses jQuery handlers so this listener doesn't re-fire and loop.
      $form.get(0).submit();
    });
  });
}

if (window.location.hash === '#yearly') {
  setDisplayYearly(true);
}
